import React, { Component } from 'react'
import SectionHeader from '../components/SectionHeader'
import Card15 from '../components/cards/Card15'
import { connect } from 'react-redux'
import { getProducts } from '../actions/MainAction'
import {changeStateValue} from '../redux/MainReducer'
import OrderSvg from '../components/svg/OrderSvg'
import SebetSvg from '../components/svg/SebetSvg'
import UserInfoPopUp from '../components/UserInfoPopUp'

export class ShoppingCart extends Component {
    state = {
        showPopup: false
    };

    togglePopup = () => {
        this.setState(prevState => ({
            showPopup: !prevState.showPopup
        }));
    };


    componentDidMount() {
        const { getProducts, lang_id, shoppingCard, changeStateValue } = this.props;
        let cart = shoppingCard;

        if (!cart || cart.length === 0) {
            const storedCart = localStorage.getItem("shoppingCard");
            if (storedCart) {
                cart = JSON.parse(storedCart);

                changeStateValue({
                    name: "shoppingCard",
                    value: cart
                });
            }
        }
        if (cart && cart.length > 0) {
            getProducts(lang_id, cart);
        }
    }

    render() {
        const {showPopup} = this.state;

        const {dataShopping}=this.props;
        console.log(dataShopping)
        return (
            <div className='container'>

                <div>
                    <SectionHeader title="Səbət" />
                </div>

                <section className='bg-[#fff] h-full w-full rounded-[12px]'>
                    {dataShopping?.map((data,i)=>{
                        return(
                            <Card15 
                            key={i}/>
                        )
                    })

                    }

                    <Card15 />
                </section>

                <div className='flex justify-end pt-[16px]' >
                    <button onClick={this.togglePopup} className='p-[4px_12px] bg-[#f05127] rounded-[6px] text-[#fff] font-[500] text-[18px] flex items-center gap-[8px]'>
                        {/* <OrderSvg /> */}
                        <SebetSvg fill="#fff" />
                        
                        Sifarisi tamamla
                    </button>
                </div>
                {showPopup && <UserInfoPopUp show={showPopup} onClose={this.togglePopup} />}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    shoppingCard: state.Data.shoppingCard,
    lang_id: state.Data.lang_id,
    dataShopping: state.Data.dataShopping,
    contentData: state.Data.contentData,
})

const mapDispatchToProps = {getProducts, changeStateValue }

export default connect(mapStateToProps, mapDispatchToProps) (ShoppingCart)